import { TemporaryCustomerInfos } from "@/apps/dashboard/buyback/core/infrastructure/repository/type/CustomerInfo/TemporaryCustomerInfos";
import TempCustomerInfosMapper from "@/apps/dashboard/buyback/core/infrastructure/mapper/buyback/customerInfo/tempCustomerInfosMapper";

const TEMP_CUSTOMER_INFOS = "TEMP_CUSTOMER_INFOS";

class TempCustomerInfosLocalStorageRepository {
  hasTemporaryCustomerInfos(): boolean {
    return localStorage.getItem(TEMP_CUSTOMER_INFOS) !== null;
  }

  getTempCustomerInfos(): TemporaryCustomerInfos {
    const tempCustomerInfosFromLocalStorage = localStorage.getItem(TEMP_CUSTOMER_INFOS);

    if (tempCustomerInfosFromLocalStorage !== null) {
      return TempCustomerInfosMapper.mapTempCustomerInfosFromString(tempCustomerInfosFromLocalStorage);
    }

    throw new Error("An error occured trying to retrieve the temporary customer infos.");
  }

  storeTempCustomerInfos(tempCustomerInfos: TemporaryCustomerInfos): void {
    localStorage.setItem(TEMP_CUSTOMER_INFOS, TempCustomerInfosMapper.mapTempCustomerInfosToString(tempCustomerInfos));
  }

  removeTempCustomerInfos(): void {
    localStorage.removeItem(TEMP_CUSTOMER_INFOS);
  }
}

export default new TempCustomerInfosLocalStorageRepository();
